import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import {
  IsoTimeSelectorComponent,
  MultiChipInputComponent,
  NgCommonModule,
} from '@principle-theorem/ng-shared';
import { DayOfWeek, DAYS_OF_WEEK } from '@principle-theorem/shared';
import { isIP } from 'is-ip';
import { startCase } from 'lodash';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserRestrictionIpOverrideFormGroup } from '../user-restriction-ip-override-form';
import { UserRestrictionScheduleFormGroup } from '../user-restriction-schedule-form';

interface IScheduleDayOption {
  key: DayOfWeek;
  label: string;
}

@Component({
  selector: 'pr-user-restriction-form',
  templateUrl: './user-restriction-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgCommonModule,
    MatCheckboxModule,
    MatDividerModule,
    IsoTimeSelectorComponent,
    MultiChipInputComponent,
  ],
})
export class UserRestrictionFormComponent {
  readonly scheduleGroup = input.required<UserRestrictionScheduleFormGroup>();
  readonly ipOverrideGroup =
    input.required<UserRestrictionIpOverrideFormGroup>();
  readonly isIpValidatorFn = isIP;
  readonly scheduleDays: IScheduleDayOption[] = DAYS_OF_WEEK.map((day) => ({
    key: day,
    label: startCase(day),
  }));
  readonly scheduleError$: Observable<string | undefined>;

  constructor() {
    this.scheduleError$ = toObservable(this.scheduleGroup).pipe(
      switchMap((group) => group.getErrorMessage$())
    );
  }
}
